import api from './api';
import router from '../../router';

//Path Regex to check if socket listener should be used
const pathRegex = /^\/plugin/;

const state = {
	error: null,
	plugins: [],
	keys: [],
	qualifications: [],
};

const getters = {};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setPlugins(state, plugins) {
		state.plugins = plugins;
	},

	setKeys(state, keys) {
		state.keys = keys;
	},

	addPlugin(state, plugin) {
		state.plugins.push(plugin);
	},

	updatePlugin(state, plugin) {
		const pluginIndex = state.plugins.findIndex((q) => q._id === plugin.id);
		if (pluginIndex != -1) {
			state.plugins[pluginIndex].name = plugin.name;
			state.plugins[pluginIndex].key = plugin.key;
			state.plugins[pluginIndex].config = plugin.config;
			state.plugins[pluginIndex].stage = plugin.stage;
			state.plugins[pluginIndex].isActive = plugin.isActive;
		}
	},

	setDeleted(state, { pluginId, deleted }) {
		const plugin = state.plugins.find((q) => q._id === pluginId);
		if (plugin !== undefined) {
			plugin.deleted = deleted;
		}
	},

	setQualifications(state, qualifications) {
		state.qualifications = qualifications;
	},
};

const actions = {
	async load({ commit }, loadDeleted = false) {
		try {
			const plugins = (await api.list(loadDeleted)).data;
			commit('setPlugins', plugins);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async loadKeys({ commit }) {
		try {
			const keys = (await api.listKeys()).data;
			commit('setKeys', keys);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async create({ commit }, plugin) {
		try {
			const result = await api.create(plugin);
			commit('addPlugin', result.data);
			return result.data;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async update({ commit }, plugin) {
		try {
			const result = await api.update(plugin);
			commit('updatePlugin', result.data);
			return result.data;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async updateName({ commit }, plugin) {
		try {
			await api.updateName(plugin);
			commit('updatePlugin', plugin);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async updateConfig({ commit }, plugin) {
		try {
			const result = await api.updateConfig(plugin);
			commit('updatePlugin', plugin);
			return result;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
			return null;
		}
	},
	async delete({ commit }, pluginId) {
		try {
			await api.delete(pluginId);
			commit('setDeleted', { pluginId, deleted: true });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async restore({ commit }, pluginId) {
		try {
			await api.update({ id: pluginId, deleted: false });
			commit('setDeleted', { pluginId, deleted: false });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async loadQualifications({ commit }) {
		try {
			const qualifications = (await api.getQualifications()).data;
			commit('setQualifications', qualifications);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
